import React from 'react';
import { Outlet } from 'react-router-dom';
import Header from './Header';

import Box from '@mui/material/Box';
import Container from '@mui/material/Container';

const Layout = () => {
	return (
		<React.Fragment>
			<Container
				sx={{
					backgroundColor: (theme) => theme.palette.common.white
				}}
			>
				<Header />
				<Box
					component='main'
					sx={{ backgroundColor: 'white', padding: '15px 25px', minHeight: '86vh' }}
				>
					<Outlet />
				</Box>
			</Container>
		</React.Fragment>
	);
};

export default Layout;
